import { getAuthorizationProperties } from "./authorizationHelper";

export function getLanguage(value) {
    return fetch(`api/Dashboard/${value}/setlanguage`, {
        method: "GET",
    });
}